import { useMemo, useState, useEffect } from 'react'
import styled from '@emotion/styled'
import Typography from '@mui/material/Typography'
import moment from 'moment'
import { string, number, oneOfType, func } from 'prop-types'
import { api } from 'api'
import { EditUser } from '../../user-management/users/edit-user'
import { t } from '@lingui/core/macro'

const Padding = styled.div`
  padding-left: 12px;
  padding-right: 12px;
  margin-top: -12px;
`

const PaddingTypography = styled(Typography)`
  padding-top: 8px;
`

export const UserDetails = ({ userId = null, onClose = () => {}, topUsers }) => {
  const [userDetail, setUserDetail] = useState({})

  useEffect(() => {
    api.get(`/api/v1/account/reports/topusers/${userId}/user-report`).then(({ data }) => {
      setUserDetail(data)
    })
  }, [])

  const user = useMemo(() => (userId && topUsers ? topUsers[userId] : {}), [topUsers, userId])

  return (
    userId && (
      <>
        <EditUser noEdit onClose={onClose} userId={userId} />
        <Padding>
          <Typography variant="body1">
            {`Submitted Codes: ${user && user.submitted_codes ? user.submitted_codes : 0}`}
          </Typography>
          <PaddingTypography variant="body1">
            {`Last Submitted: ${
              (user && user.last_submission && moment(user.last_submission).fromNow()) || 'Never'
            }`}
          </PaddingTypography>
          {userDetail.templates?.length ? (
            <>
              <Typography variant="h6" style={{ paddingTop: 24, paddingBottom: 12 }}>
                {t`Submissions by template`}
              </Typography>
              {userDetail.templates.map(t => (
                <div key={t.id ?? t.name} style={{ display: 'flex', paddingBottom: 8 }}>
                  <div style={{ flex: 1 }}>{t.name}</div>
                  <div style={{ flex: 1 }}>{t.codes}</div>
                </div>
              ))}
            </>
          ) : null}
          {userDetail.summary?.length ? (
            <>
              <Typography variant="h6" style={{ paddingTop: 24, paddingBottom: 12 }}>
                {t`Submissions by month`}
              </Typography>
              {userDetail.summary.map(t => (
                <div key={`${t.month}/${t.year}`} style={{ display: 'flex', paddingBottom: 8 }}>
                  <div style={{ flex: 1 }}>
                    {t.month}/{t.year}
                  </div>
                  <div style={{ flex: 1 }}>{t.codes}</div>
                </div>
              ))}
            </>
          ) : null}
        </Padding>
      </>
    )
  )
}

UserDetails.propTypes = {
  userId: oneOfType([string, number]),
  onClose: func,
}
